/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusTextlineDto
 */
export interface NovitusTextlineDto {
    /**
     * Tekst pogrubiony
     * @type {boolean}
     * @memberof NovitusTextlineDto
     */
    bold?: boolean;
    /**
     * Odwrócone kolory
     * @type {boolean}
     * @memberof NovitusTextlineDto
     */
    invers?: boolean;
    /**
     * Wycentrowany tekst
     * @type {boolean}
     * @memberof NovitusTextlineDto
     */
    center?: boolean;
    /**
     * Wyrównanie do prawej
     * @type {boolean}
     * @memberof NovitusTextlineDto
     */
    right?: boolean;
    /**
     * Numer czcionki (0-2)
     * @type {number}
     * @memberof NovitusTextlineDto
     */
    font_number?: number;
    /**
     * Czcionka powiększona
     * @type {boolean}
     * @memberof NovitusTextlineDto
     */
    big?: boolean;
    /**
     * Czcionka podwyższona x razy.
     * @type {number}
     * @memberof NovitusTextlineDto
     */
    height?: NovitusTextlineDtoHeightEnum;
    /**
     * Czcionka poszerzona x razy.
     * @type {number}
     * @memberof NovitusTextlineDto
     */
    width?: NovitusTextlineDtoWidthEnum;
    /**
     * Zawartość tekstowa
     * @type {string}
     * @memberof NovitusTextlineDto
     */
    text: string;
    /**
     * Oznacz jako zamaskowane
     * @type {boolean}
     * @memberof NovitusTextlineDto
     */
    masked: boolean;
}


/**
 * @export
 */
export const NovitusTextlineDtoHeightEnum = {
    NUMBER_2: 2,
    NUMBER_4: 4
} as const;
export type NovitusTextlineDtoHeightEnum = typeof NovitusTextlineDtoHeightEnum[keyof typeof NovitusTextlineDtoHeightEnum];

/**
 * @export
 */
export const NovitusTextlineDtoWidthEnum = {
    NUMBER_2: 2,
    NUMBER_4: 4
} as const;
export type NovitusTextlineDtoWidthEnum = typeof NovitusTextlineDtoWidthEnum[keyof typeof NovitusTextlineDtoWidthEnum];


/**
 * Check if a given object implements the NovitusTextlineDto interface.
 */
export function instanceOfNovitusTextlineDto(value: object): value is NovitusTextlineDto {
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('masked' in value) || value['masked'] === undefined) return false;
    return true;
}

export function NovitusTextlineDtoFromJSON(json: any): NovitusTextlineDto {
    return NovitusTextlineDtoFromJSONTyped(json, false);
}

export function NovitusTextlineDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusTextlineDto {
    if (json == null) {
        return json;
    }
    return {
        
        'bold': json['bold'] == null ? undefined : json['bold'],
        'invers': json['invers'] == null ? undefined : json['invers'],
        'center': json['center'] == null ? undefined : json['center'],
        'right': json['right'] == null ? undefined : json['right'],
        'font_number': json['font_number'] == null ? undefined : json['font_number'],
        'big': json['big'] == null ? undefined : json['big'],
        'height': json['height'] == null ? undefined : json['height'],
        'width': json['width'] == null ? undefined : json['width'],
        'text': json['text'],
        'masked': json['masked'],
    };
}

export function NovitusTextlineDtoToJSON(value?: NovitusTextlineDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'bold': value['bold'],
        'invers': value['invers'],
        'center': value['center'],
        'right': value['right'],
        'font_number': value['font_number'],
        'big': value['big'],
        'height': value['height'],
        'width': value['width'],
        'text': value['text'],
        'masked': value['masked'],
    };
}

